<div [formGroup]="form" *ngIf="form" [class]="!isValid() ? 'form-group input-group has-error' : 'form-group input-group'">
  <input [formControlName]="renderable.id"
       [type]="renderable.type"
       class="form-control"/>
</div>
